<!-- eslint-disable prettier/prettier -->

<!-- 393: rekryteringslots dalarna. 
     390: Applicationportal Sweden-->
<template>
  <div
    v-if="
      props.company.Container.DTO.id === 390 ||
      props.company.Container.DTO.id === 393
    "
  >
    <CustomerGdpRrekryteringslots :company="props.company" />
  </div>
  <div
    v-else-if="
      props.company.Container.DTO.id !== 390 ||
      props.company.Container.DTO.id !== 393
    "
  >
    <CustomerGdprDefault :company="props.company" />
  </div>
</template>
<script setup lang="ts">
import { Profile } from "@/models/Profile";
import { defineProps } from "vue";
import CustomerGdprDefault from "./CustomerGdprDefault.vue";
import CustomerGdpRrekryteringslots from "./CustomerGdpRrekryteringslots.vue";

const props = defineProps({
  company: {
    type: Profile,
    required: true,
  },
});
</script>
